import React, { useState, useEffect } from 'react';
import {Form, Row, Col, Input, DatePicker, Button, Table, Statistic, Spin, Card} from 'antd';

import {Dinheiro} from '../../../componentes/Numeros/dinheiro';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenDollar, faSigma, faAbacus, faFileSpreadsheet } from '@fortawesome/pro-duotone-svg-icons';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {  LoadingOutlined  } from '@ant-design/icons';

import {useProdutos} from '../useProdutos';

const PosicaoEstoque = () => {
    const [produtos, setProdutos] = useState([]);
    const [sumario, setSumario] = useState({
        totalCusto: 0,
        totalFaturamento: 0,
        totalLucro: 0
    });
    
    const {listarProdutosEstoque} = useProdutos();

    const [loading, setLoading] = useState(false);

    const formRef = React.createRef();

    const buscarProdutos = async () => {
        
        const {termo, dataLimite} = formRef.current.getFieldsValue();
        let dataTratada;
        if(dataLimite){
            dataTratada = moment(dataLimite, "YYYY-MM-DD").format("YYYY-MM-DD");
        } else {
            dataTratada = moment().format("YYYY-MM-DD");
        }
        
        const produtos = await listarProdutosEstoque(termo, dataTratada);
        console.log(produtos);
        defineProdutos(produtos);

    }
    const defineProdutos = (produtos) => {
        const novoProduto = produtos.map(produto => {
            produto.key = produto.uuid;
            const custo = parseFloat((produto.valorCusto || 0));
            const valorProduto = parseFloat((produto.vUnCom || 0));
            const quantidadeEstoque = parseFloat((produto.saldoEstoque || 0));
            const quantidadePositiva = quantidadeEstoque > 0 ? quantidadeEstoque : 0;
            // lucro total por item considerando apenas quantidades positivas
            produto.lucroTotal = (valorProduto - custo) * quantidadePositiva;
            return produto;
        });
        setProdutos(novoProduto);
        
    }

    useEffect(() => {
        buscarProdutos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        calculaSumario(produtos);
        // buscarProdutos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [produtos]);

    const calculaSumario = (produtos) => {
        let totalCusto = 0;
        let totalFaturamento = 0;
        let totalLucro = 0;

        produtos.forEach(produto => {
            const custo = parseFloat((produto.valorCusto || 0));
            const valorProduto = parseFloat((produto.vUnCom || 0));
            const quantidadeEstoque = parseFloat((produto.saldoEstoque || 0));

            totalCusto += custo * quantidadeEstoque;
            const quantidadePositiva = quantidadeEstoque > 0 ? quantidadeEstoque : 0;
            totalFaturamento += valorProduto * quantidadePositiva;
            totalLucro += (valorProduto - custo) * quantidadePositiva;
        });

        const novoSumario = {totalCusto, totalFaturamento, totalLucro};
        setSumario(novoSumario);
    }

    
    const renderizaBotaoBuscar = () => {

        const buscarHandleClick = async () => {
            setLoading(true);
            await buscarProdutos();
            setLoading(false);
    
            
            
            
        }
        return (<Button type="primary" loading={loading} htmlType="submit" onClick={buscarHandleClick}>Buscar</Button>)
    }

    const exportar = () => {

        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';


    
        const textData = produtos.map(produto => {
            delete produto.key;
            produto.saldoEstoque = produto.saldoEstoque + " " + (produto.uCom || "");
            const {codigo, descricao,ncm,eanCom,vUnCom,saldoEstoque,valorCusto,lucro,lucroTotal} = produto;
            return{
                codigo,	
                descricao,	
                ncm,	
                eanCom,	
                vUnCom,		
                saldoEstoque,
                valorCusto,	
                lucro,	
                lucroTotal

            }

            
        });

               
        const ws = XLSX.utils.json_to_sheet(textData);

        

        ws['!cols'] = { width: 200 }

        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        
        const data = new Blob([excelBuffer], {type: fileType});
        
        let fileName = "posicao-estoque";
        if(formRef.current.getFieldValue("dataLimite")){
            fileName = fileName + "-" +moment(formRef.current.getFieldValue("dataLimite")).format("DD-MM-YYYY");
        }
        FileSaver.saveAs(data, fileName + ".xlsx");


        
    }

    const columns = [{
        title: "Codigo",
        dataIndex: "codigo",
        key: "codigo",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.codigo < b.codigo ? -1 : a.codigo > b.codigo ? 1 : 0)
    },{
        title: "Descricao",
        dataIndex: "descricao",
        key: "descricao",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.descricao < b.descricao ? -1 : a.descricao > b.descricao ? 1 : 0)
    },{
        title: "NCM",
        dataIndex: "ncm",
        key: "ncm",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.ncm < b.ncm ? -1 : a.ncm > b.ncm ? 1 : 0)
    },{
        title: "EAN",
        dataIndex: "ean",
        key: "ean",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.eanCom < b.eanCom ? -1 : a.eanCom > b.eanCom ? 1 : 0)
    },{
        title: "Estoque",
        dataIndex: "saldoEstoque",
        key: "saldoEstoque",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.saldoEstoque < b.saldoEstoque ? -1 : a.saldoEstoque > b.saldoEstoque ? 1 : 0),
        render: (texto, produto, indice) => {
            return <div style={{textAlign: "center"}}>{produto.saldoEstoque} {produto.uCom}</div>
        }
    },{
        title: "Custo",
        dataIndex: "valorCusto",
        key: "valorCusto",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.valorCusto < b.valorCusto ? -1 : a.valorCusto > b.valorCusto ? 1 : 0),
        render: (texto) => {
            if(!texto) texto = "0";
            return (<Dinheiro 
                value={texto}
            ></Dinheiro>);
        }
    },{
        title: "Valor",
        dataIndex: "vUnCom",
        key: "vUnCom",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.vUnCom < b.vUnCom ? -1 : a.vUnCom > b.vUnCom ? 1 : 0),
        render: (texto) => {
            if(!texto) texto = "0";
            return (<Dinheiro 
                value={texto}
            ></Dinheiro>);
        }
    },{
        title: "Lucro",
        dataIndex: "lucroTotal",
        key: "lucro",
        sortDirections: ['descend', 'ascend'],
        sorter: (a, b) => (a.lucro < b.lucro ? -1 : a.lucro > b.lucro ? 1 : 0),
        render: (texto) => {
            if(!texto) texto = "0";
            return (<Dinheiro 
                value={texto}
            ></Dinheiro>);
        }
    }];

    return (<>
        <Row>
            <Col span={24} style={{textAlign: "left", padding: "23px", paddingBottom: "0"}}>
                <h1>Posição Estoque</h1>
            </Col>
        </Row>
        
            

        <Form layout="inline" ref={formRef}>
         <Row style={{padding: "0 23px"}} align="bottom" gutter={[8,0]}>
                  
                        <Col>
                            <Row style={{fontSize: "12px"}}>
                                Descricao
                            </Row>
                            <Row>
                                <Form.Item
                                    name="termo"
                                    initialValue=""
                                >
                                    <Input prefix="Buscar Por:" />
                                </Form.Item>
                            </Row>
                        </Col>
                        <Col>
                            <Row style={{fontSize: "12px"}}>
                                Data de Posicao
                            </Row>
                            <Row>
                                  <Form.Item
                                    name="dataLimite"
                                    initialValue={moment()}
                                >
                                    <DatePicker format="DD/MM/YYYY" />
                                </Form.Item>
                            </Row>
                        </Col>
                        <Col>
                            <Form.Item>
                                {renderizaBotaoBuscar()}
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item>
                                <Button color="success" onClick={exportar}>
                                    <FontAwesomeIcon icon={faFileSpreadsheet} color="green" size="large"></FontAwesomeIcon>
                                    Exportar
                                </Button>
                            </Form.Item>
                        </Col>  
        </Row> 
        </Form>

         

        <Row style={{marginTop: "12px", position: "sticky", top: "55px", zIndex: "9"}}>
            <Col span={24}>
                <Card style={{padding: "0px 0px"}}>
                    <Row justify="end" gutter={36} style={{textAlign: "right"}}>
                        <Col>
                            <Statistic  title="Custo Total" value={sumario.totalCusto} valueStyle={{fontSize: "1em", color: "red"}} decimalSeparator="," formatter={value => (<Dinheiro value={value}></Dinheiro>)} prefix={<FontAwesomeIcon icon={faEnvelopeOpenDollar} />} />
                        </Col>
                        <Col>
                            <Statistic title="Faturamento Previsto" value={sumario.totalFaturamento} valueStyle={{fontSize: "1em", color: "blue"}} formatter={value => (<Dinheiro value={value}></Dinheiro>)} prefix={<FontAwesomeIcon icon={faSigma} />} />
                        </Col>
                        <Col>
                            <Statistic title="Lucro Previsto" formatter={value => (<Dinheiro value={value}></Dinheiro>)} valueStyle={{fontSize: "1em", color: "green"}}  value={sumario.totalLucro} prefix={<FontAwesomeIcon icon={faAbacus} />} />
                        </Col>
                    </Row>
                </Card>

            </Col>
            
        </Row>               
        <Row style={{background: "#FFF", marginTop: "12px"}}>
           <Col span={24}>

                <Spin spinning={loading} style={{width: '100%'}} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>

                    <Table 
                        id="tblEstoque"
                        
                        
                        pagination={false}
                        style={{
                            width: '100%'
                        }}
                        size="small"
                        dataSource={produtos}
                        columns={columns}

                        
                    ></Table>
                </Spin>
           </Col>
        </Row>
    </>);
}

export {PosicaoEstoque};